export default "__VITE_ASSET__yyqWjDDE__"